<template>
  <div class="kaumxstrata">
    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.message }}
    </v-snackbar>
    <v-card style="margin-top: 250px">
    <v-breadcrumbs :items="item">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item
          :href="goToRoute(item.href)"
          :disabled="item.disabled"
        >
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>

    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ $t("kaumxstrata") }} {{ title }}
      </v-card-title>

      <v-container>
        <v-form ref="formkaumxstrata">
          <v-row>
            <v-col cols="12" sm="4">
              <v-autocomplete
                outlined
                dense
                v-bind:label="$t('negeri')"
                :items="lookupnegeri"
                :item-text="item => item.negeriID +' - '+ item.negeri"
                v-model="paparnegeriexport"
                :disabled="disablenegeri"
                v-on:change="paparlookupsample"
                return-object
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3">
              <v-autocomplete
                outlined
                dense
                v-bind:label="$t('sample')"
                return-object
                :items="lookupsample"
                item-text="sample"
                v-model="paparsample"
                v-on:change="paparpusinganexport"
                :disabled="disablesample"
                ref="fokuspaparsample"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3">
              <v-autocomplete
                outlined
                dense
                v-bind:label="$t('pusingan')"
                return-object
                :items="lookuppusingan"
                item-text="pusingan"
                v-model="paparpusinganexport"
              ></v-autocomplete>
            </v-col>

            <v-col class="text-right">
             <v-btn
                    color="blue white white--text"
                     @click="cari()">
                     <span class="material-icons">search</span> 
                    {{ $t("cari") }}</v-btn>
            </v-col>

            <Overlay v-show="showOverlay"/>

            <v-col v-show="isShowing" class="text-right">
                <v-btn type="button" color="red white white--text" value="Create PDF"
                  id="btPrint" @click="downloadPDF('pdf')"><span class='fas fa-file-pdf' style='font-size:24px'></span>
                  {{ $t("muatturun") }} 
           </v-btn>
            &nbsp;

             <v-btn type="button" color="green white white--text"
                @click="downloadExcel('xls')"><span class='fas fa-file-excel' style='font-size:24px'></span>
                {{ $t("muatturun") }} 
              </v-btn></v-col></v-row>
          </v-form>
         
        <v-card-text>
          <v-simple-table fixed-header dense ref="exportable_table" class="table-bordered" id="table1">
            <thead>
            <tr>
              <th colspan="1" style="text-align: center; border: none;">
                <img src="https://i.ibb.co/WBrF5yQ/JATANEGARA.png" alt="JataNegara" width="80" height="70">
              </th>
              <th colspan="11" style="text-align: center; border: none;" class="text-h6">
                  SISTEM SURVEI PENDAPATAN, PERBELANJAAN ISI RUMAH DAN KEMUDAHAN ASAS  <br>
                  PENDAPATAN ISI RUMAH BULANAN MENGIKUT KUMPULAN ETNIK KETUA ISI RUMAH DAN STRATA
              </th>
              <th colspan="1" style="text-align: center; border: none;">
                <img src="https://i.ibb.co/bX8FgBj/HIES.png" alt="HIES/BA" width="80" height="70">
              </th>
            </tr>

             <tr>
              <th rowspan="2" ><strong>KUMPULAN ETNIK</strong></th>
              
              <th colspan="3" style="text-align:center;"><strong>2019</strong></th>
              <th colspan="3" style="text-align:center;"><strong>2022 (TANPA WAJARAN)</strong></th>
              <th colspan="3" style="text-align:center;"><strong>2022 (BERWAJARAN)</strong></th>
              <th colspan="3" style="text-align:center;"><strong>CAGR 2022</strong></th>
              </tr>
              <tr>
              <th style="text-align:center;" ><strong>BANDAR</strong></th>
              <th style="text-align:center;" ><strong>LUAR BANDAR</strong></th>
              <th style="text-align:center;" ><strong>JUMLAH</strong></th>
              
              <th style="text-align:center;" ><strong>BANDAR</strong></th>
              <th style="text-align:center;" ><strong>LUAR BANDAR</strong></th>
              <th style="text-align:center;" ><strong>JUMLAH</strong></th>

              <th style="text-align:center;" ><strong>BANDAR</strong></th>
              <th style="text-align:center;" ><strong>LUAR BANDAR</strong></th>
              <th style="text-align:center;" ><strong>JUMLAH</strong></th>

              <th style="text-align:center;" ><strong>BANDAR</strong></th>
              <th style="text-align:center;" ><strong>LUAR BANDAR</strong></th>
              <th style="text-align:center;" ><strong>JUMLAH</strong></th>

              </tr>
          </thead>
              <tbody>
                <tr>
                    <td colspan="13" style="text-align: left"><strong>
                      Pendapatan Purata
                    </strong></td>
                </tr>

                <tr >
                  <td >
                      Jumlah
                  </td>
                  <template v-for="item in dataz.dataPurata2019" >
                    <td v-if="item.Row == '1' && item.Col == '10'" :key="item.index" style="text-align:center;">
                      {{item.Value}}
                    </td>
                  </template>
                  <template v-for="item in dataz.dataPurata2019" >
                    <td v-if="item.Row == '1' && item.Col == '11'" :key="item.index" style="text-align:center;">
                      {{item.Value}}
                    </td>
                  </template>
                  <template v-for="item in dataz.dataPurata2019" >
                    <td v-if="item.Row == '1' && item.Col == '12'" :key="item.index" style="text-align:center;">
                      {{item.Value}}
                    </td>
                  </template>

                  <!-- PENDAPATAN PURATA TANPA BERWAJARAN -->
                  <td style="text-align:center;">
                    {{calculateJumlahBandarLuarBandar2022('1')}}
                  </td>

                  <td style="text-align:center;">
                    {{calculateJumlahBandarLuarBandar2022('2')}}
                  </td>

                  <td style="text-align:center;">
                    {{calculatePenkasarJumlah()}}
                  </td>

                  <!-- PENDAPATAN PURATA BERWAJARAN -->
                  <td style="text-align:center;">
                    {{calculateJumlahBandarLuarBandar2022Berwajaran('1')}}
                  </td>
                  
                  <td style="text-align:center;">
                    {{calculateJumlahBandarLuarBandar2022Berwajaran('2')}}
                  </td>

                  <td style="text-align:center;">
                    {{calculatePenkasarJumlahBerwajaran('1','1')}}
                  </td>

                  <!-- PENDAPATAN PURATA CAGR 2022 -->
                  <td style="text-align:center;">
                    {{calculateJumlahCAGR2022PendapatanPurata('Bandar')}}
                  </td>
                  
                  <td style="text-align:center;">
                    {{calculateJumlahCAGR2022PendapatanPurata('LuarBandar')}}
                  </td>

                  <td style="text-align:center;">
                    {{calculateJumlahCAGR2022PendapatanPurata('Jumlah')}}
                  </td>
                </tr>


                <tr >
                    <td>
                      Bumiputera
                    </td>
                    <template v-for="item in dataz.dataPurata2019" >
                      <td v-if="item.Row == '2' && item.Col == '10'" :key="item.index" style="text-align:center;">
                        {{item.Value}}
                      </td>
                    </template>
                    <template v-for="item in dataz.dataPurata2019" >
                      <td v-if="item.Row == '2' && item.Col == '11'" :key="item.index" style="text-align:center;">
                         {{item.Value}}
                      </td>
                    </template>
                    <template v-for="item in dataz.dataPurata2019" >
                      <td v-if="item.Row == '2' && item.Col == '12'" :key="item.index" style="text-align:center;">
                         {{item.Value}}
                      </td>
                    </template>

                    <!-- PENDAPATAN PURATA TANPA BERWAJARAN -->
                    <td style="text-align:center;">
                      {{calculateBumiBandarLuarBandar2022('1')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateBumiBandarLuarBandar2022('2')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculatePenkasarBumi()}}
                    </td>

                    <!-- PENDAPATAN PURATA BERWAJARAN -->
                    <td style="text-align:center;">
                      {{calculateBumiBandarLuarBandar2022Berwajaran('1')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateBumiBandarLuarBandar2022Berwajaran('2')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculatePenkasarBumiBerwajaran()}}
                    </td>

                    <!-- PENDAPATAN PURATA CAGR 2022 -->
                    <td style="text-align:center;">
                      {{calculateJumlahCAGR2022PendapatanPurata('BumiBandar')}}
                    </td>
                    
                    <td style="text-align:center;">
                      {{calculateJumlahCAGR2022PendapatanPurata('BumiLuarBandar')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateJumlahCAGR2022PendapatanPurata('BumiJumlah')}}
                    </td> 
                </tr>


                <tr >
                  <td >
                      Cina
                  </td>
                  <template v-for="item in dataz.dataPurata2019" >
                    <td v-if="item.Row == '3' && item.Col == '10'" :key="item.index" style="text-align:center;">
                      {{item.Value}}
                    </td>
                  </template>
                  <template v-for="item in dataz.dataPurata2019" >
                    <td v-if="item.Row == '3' && item.Col == '11'" :key="item.index" style="text-align:center;">
                      {{item.Value}}
                    </td>
                  </template>
                  <template v-for="item in dataz.dataPurata2019" >
                    <td v-if="item.Row == '3' && item.Col == '12'" :key="item.index" style="text-align:center;">
                      {{item.Value}}
                    </td>
                  </template>

                    <!-- PENDAPATAN PURATA TANPA BERWAJARAN -->
                    <td style="text-align:center;">
                      {{calculateCinaBandarLuarBandar2022('1')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateCinaBandarLuarBandar2022('2')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculatePenkasarCina()}}
                    </td>

                    <!-- PENDAPATAN PURATA BERWAJARAN -->
                    <td style="text-align:center;">
                      {{calculateCinaBandarLuarBandar2022Berwajaran('1')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateCinaBandarLuarBandar2022Berwajaran('2')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculatePenkasarCinaBerwajaran()}}
                    </td>

                    <!-- PENDAPATAN PURATA CAGR 2022 -->
                    <td style="text-align:center;">
                      {{calculateJumlahCAGR2022PendapatanPurata('CinaBandar')}}
                    </td>
                    
                    <td style="text-align:center;">
                      {{calculateJumlahCAGR2022PendapatanPurata('CinaLuarBandar')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateJumlahCAGR2022PendapatanPurata('CinaJumlah')}}
                    </td> 
                </tr>

                <tr >
                    <td>
                      India
                    </td>
                    <template v-for="item in dataz.dataPurata2019" >
                      <td v-if="item.Row == '4' && item.Col == '10'" :key="item.index" style="text-align:center;">
                        {{item.Value}}
                      </td>
                    </template>
                    <template v-for="item in dataz.dataPurata2019" >
                      <td v-if="item.Row == '4' && item.Col == '11'" :key="item.index" style="text-align:center;">
                         {{item.Value}}
                      </td>
                    </template>
                    <template v-for="item in dataz.dataPurata2019" >
                      <td v-if="item.Row == '4' && item.Col == '12'" :key="item.index" style="text-align:center;">
                         {{item.Value}}
                      </td>
                    </template>

                    <!-- PENDAPATAN PURATA TANPA BERWAJARAN -->
                    <td style="text-align:center;">
                      {{calculateIndiaBandarLuarBandar2022('1')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateIndiaBandarLuarBandar2022('2')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculatePenkasarIndia()}}
                    </td>

                    <!-- PENDAPATAN PURATA BERWAJARAN -->
                    <td style="text-align:center;">
                      {{calculateIndiaBandarLuarBandar2022Berwajaran('1')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateIndiaBandarLuarBandar2022Berwajaran('2')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculatePenkasarIndiaBerwajaran()}}
                    </td>

                    <!-- PENDAPATAN PURATA CAGR 2022 -->
                    <td style="text-align:center;">
                      {{calculateJumlahCAGR2022PendapatanPurata('IndiaBandar')}}
                    </td>
                    
                    <td style="text-align:center;">
                      {{calculateJumlahCAGR2022PendapatanPurata('IndiaLuarBandar')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateJumlahCAGR2022PendapatanPurata('IndiaJumlah')}}
                    </td> 
                </tr>

                <tr >
                  <td >
                      Lain-lain
                  </td>
                  <template v-for="item in dataz.dataPurata2019" >
                    <td v-if="item.Row == '5' && item.Col == '10'" :key="item.index" style="text-align:center;">
                      {{item.Value}}
                    </td>
                  </template>
                  <template v-for="item in dataz.dataPurata2019" >
                    <td v-if="item.Row == '5' && item.Col == '11'" :key="item.index" style="text-align:center;">
                      {{item.Value}}
                    </td>
                  </template>
                  <template v-for="item in dataz.dataPurata2019" >
                    <td v-if="item.Row == '5' && item.Col == '12'" :key="item.index" style="text-align:center;">
                      {{item.Value}}
                    </td>
                  </template>

                    <!-- PENDAPATAN PURATA TANPA BERWAJARAN -->
                   <td style="text-align:center;">
                      {{calculateLainBandarLuarBandar2022('1')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateLainBandarLuarBandar2022('2')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculatePenkasarLain()}}
                    </td>

                    <!-- PENDAPATAN PURATA BERWAJARAN -->
                    <td style="text-align:center;">
                      {{calculateLainBandarLuarBandar2022Berwajaran('1')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateLainBandarLuarBandar2022Berwajaran('2')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculatePenkasarLainBerwajaran()}}
                    </td>

                    <!-- PENDAPATAN PURATA CAGR 2022 -->
                    <td style="text-align:center;">
                      {{calculateJumlahCAGR2022PendapatanPurata('LainBandar')}}
                    </td>
                    
                    <td style="text-align:center;">
                      {{calculateJumlahCAGR2022PendapatanPurata('LainLuarBandar')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateJumlahCAGR2022PendapatanPurata('LainJumlah')}}
                    </td> 
                </tr>


                <tr >
                    <td colspan="13" style="text-align: left"><strong>
                      Pendapatan Penengah
                    </strong></td>
                </tr>

                <tr >
                  <td>
                      Jumlah
                  </td>

                  <template v-for="item in dataz.dataPurata2019" >
                    <td v-if="item.Row == '1' && item.Col == '7'" :key="item.index" style="text-align:center;">
                      {{item.Value}}
                    </td>
                  </template>
                  <template v-for="item in dataz.dataPurata2019" >
                    <td v-if="item.Row == '1' && item.Col == '8'" :key="item.index" style="text-align:center;">
                      {{item.Value}}
                    </td>
                  </template>
                  <template v-for="item in dataz.dataPurata2019" >
                    <td v-if="item.Row == '1' && item.Col == '9'" :key="item.index" style="text-align:center;">
                      {{item.Value}}
                    </td>
                  </template>

                  <!-- PENDAPATAN PENENGAH TANPA BERWAJARAN -->
                  <td style="text-align:center;">
                    {{calculatePenengahJumlahBandarLuarBandar2022('1')}}
                  </td>

                  <td style="text-align:center;">
                    {{calculatePenengahJumlahBandarLuarBandar2022('2')}}
                  </td>

                  <td style="text-align:center;">
                    {{calculatePenengahJPKASBJumlah()}}
                  </td>

                  <!-- PENDAPATAN PENENGAH BERWAJARAN -->
                  <td style="text-align:center;">
                    {{calculateJumlahBandarLuarBandar2022PenengahBerwajaran('1')}}
                  </td>

                  <td style="text-align:center;">
                    {{calculateJumlahBandarLuarBandar2022PenengahBerwajaran('2')}}
                  </td>

                  <td style="text-align:center;">
                    {{calculateJumlah2022PenengahBerwajaran()}}
                  </td>

                  <!-- PENDAPATAN PENENGAH CAGR 2022 -->
                  <td style="text-align:center;">
                    {{calculateJumlahCAGR2022PendapatanPenengah('Bandar')}}
                  </td>
                  
                  <td style="text-align:center;">
                    {{calculateJumlahCAGR2022PendapatanPenengah('LuarBandar')}}
                  </td>

                  <td style="text-align:center;">
                    {{calculateJumlahCAGR2022PendapatanPenengah('Jumlah')}}
                  </td>
                </tr>

                <tr >
                    <td>
                      Bumiputera
                    </td>
                    <template v-for="item in dataz.dataPurata2019" >
                      <td v-if="item.Row == '2' && item.Col == '7'" :key="item.index" style="text-align:center;">
                        {{item.Value}}
                      </td>
                    </template>
                    <template v-for="item in dataz.dataPurata2019" >
                      <td v-if="item.Row == '2' && item.Col == '8'" :key="item.index" style="text-align:center;">
                         {{item.Value}}
                      </td>
                    </template>
                    <template v-for="item in dataz.dataPurata2019" >
                      <td v-if="item.Row == '2' && item.Col == '9'" :key="item.index" style="text-align:center;">
                         {{item.Value}}
                      </td>
                    </template>

                  <!-- PENDAPATAN PENENGAH TANPA BERWAJARAN -->
                    <td style="text-align:center;">
                      {{calculatePenengahBumiBandarLuarBandar2022('1')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculatePenengahBumiBandarLuarBandar2022('2')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculatePenengahJPKASBBumi()}}
                    </td>

                    <!-- PENDAPATAN PENENGAH BERWAJARAN -->
                    <td style="text-align:center;">
                      {{calculateBumiBandarLuarBandar2022PenengahBerwajaran('1')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateBumiBandarLuarBandar2022PenengahBerwajaran('2')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateBumi2022PenengahBerwajaran()}}
                    </td>

                    <!-- PENDAPATAN PENENGAH CAGR 2022 -->
                  <td style="text-align:center;">
                    {{calculateJumlahCAGR2022PendapatanPenengah('BumiBandar')}}
                  </td>
                  
                  <td style="text-align:center;">
                    {{calculateJumlahCAGR2022PendapatanPenengah('BumiLuarBandar')}}
                  </td>

                  <td style="text-align:center;">
                    {{calculateJumlahCAGR2022PendapatanPenengah('BumiJumlah')}}
                  </td>
                </tr>
                <tr >
                    <td>
                      Cina
                    </td>
                    <template v-for="item in dataz.dataPurata2019" >
                    <td v-if="item.Row == '3' && item.Col == '7'" :key="item.index" style="text-align:center;">
                      {{item.Value}}
                    </td>
                  </template>
                  <template v-for="item in dataz.dataPurata2019" >
                    <td v-if="item.Row == '3' && item.Col == '8'" :key="item.index" style="text-align:center;">
                      {{item.Value}}
                    </td>
                  </template>
                  <template v-for="item in dataz.dataPurata2019" >
                    <td v-if="item.Row == '3' && item.Col == '9'" :key="item.index" style="text-align:center;">
                      {{item.Value}}
                    </td>
                  </template>

                  <!-- PENDAPATAN PENENGAH TANPA BERWAJARAN -->
                    <td style="text-align:center;">
                      {{calculatePenengahCinaBandarLuarBandar2022('1')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculatePenengahCinaBandarLuarBandar2022('2')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculatePenengahJPKASBCina()}}
                    </td>

                    <!-- PENDAPATAN PENENGAH BERWAJARAN -->
                    <td style="text-align:center;">
                      {{calculateCinaBandarLuarBandar2022PenengahBerwajaran('1')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateCinaBandarLuarBandar2022PenengahBerwajaran('2')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateCina2022PenengahBerwajaran()}}
                    </td>

                    <!-- PENDAPATAN PENENGAH CAGR 2022 -->
                  <td style="text-align:center;">
                    {{calculateJumlahCAGR2022PendapatanPenengah('CinaBandar')}}
                  </td>
                  
                  <td style="text-align:center;">
                    {{calculateJumlahCAGR2022PendapatanPenengah('CinaLuarBandar')}}
                  </td>

                  <td style="text-align:center;">
                    {{calculateJumlahCAGR2022PendapatanPenengah('CinaJumlah')}}
                  </td>
                </tr>

                <tr >
                    <td>
                      India
                    </td>
                    <template v-for="item in dataz.dataPurata2019" >
                      <td v-if="item.Row == '4' && item.Col == '7'" :key="item.index" style="text-align:center;">
                        {{item.Value}}
                      </td>
                    </template>
                    <template v-for="item in dataz.dataPurata2019" >
                      <td v-if="item.Row == '4' && item.Col == '8'" :key="item.index" style="text-align:center;">
                         {{item.Value}}
                      </td>
                    </template>
                    <template v-for="item in dataz.dataPurata2019" >
                      <td v-if="item.Row == '4' && item.Col == '9'" :key="item.index" style="text-align:center;">
                         {{item.Value}}
                      </td>
                    </template>

                  <!-- PENDAPATAN PENENGAH TANPA BERWAJARAN -->
                    <td style="text-align:center;">
                      {{calculatePenengahIndiaBandarLuarBandar2022('1')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculatePenengahIndiaBandarLuarBandar2022('2')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculatePenengahJPKASBIndia()}}
                    </td>

                    <!-- PENDAPATAN PENENGAH BERWAJARAN -->
                    <td style="text-align:center;">
                      {{calculateIndiaBandarLuarBandar2022PenengahBerwajaran('1')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateIndiaBandarLuarBandar2022PenengahBerwajaran('2')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateIndia2022PenengahBerwajaran()}}
                    </td>

                    <!-- PENDAPATAN PENENGAH CAGR 2022 -->
                  <td style="text-align:center;">
                    {{calculateJumlahCAGR2022PendapatanPenengah('IndiaBandar')}}
                  </td>
                  
                  <td style="text-align:center;">
                    {{calculateJumlahCAGR2022PendapatanPenengah('IndiaLuarBandar')}}
                  </td>

                  <td style="text-align:center;">
                    {{calculateJumlahCAGR2022PendapatanPenengah('IndiaJumlah')}}
                  </td>
                </tr>
                <tr >
                    <td>
                      Lain-lain
                    </td>
                    <template v-for="item in dataz.dataPurata2019" >
                    <td v-if="item.Row == '5' && item.Col == '7'" :key="item.index" style="text-align:center;">
                      {{item.Value}}
                    </td>
                  </template>
                  <template v-for="item in dataz.dataPurata2019" >
                    <td v-if="item.Row == '5' && item.Col == '8'" :key="item.index" style="text-align:center;">
                      {{item.Value}}
                    </td>
                  </template>
                  <template v-for="item in dataz.dataPurata2019" >
                    <td v-if="item.Row == '5' && item.Col == '9'" :key="item.index" style="text-align:center;">
                      {{item.Value}}
                    </td>
                  </template>

                  <!-- PENDAPATAN PENENGAH TANPA BERWAJARAN -->
                   <td style="text-align:center;">
                      {{calculatePenengahLainBandarLuarBandar2022('1')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculatePenengahLainBandarLuarBandar2022('2')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculatePenengahJPKASBLain()}}
                    </td>

                    <!-- PENDAPATAN PENENGAH BERWAJARAN -->
                    <td style="text-align:center;">
                      {{calculateLainBandarLuarBandar2022PenengahBerwajaran('1')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateLainBandarLuarBandar2022PenengahBerwajaran('2')}}
                    </td>

                    <td style="text-align:center;">
                      {{calculateLain2022PenengahBerwajaran()}}
                    </td>

                    <!-- PENDAPATAN PENENGAH CAGR 2022 -->
                  <td style="text-align:center;">
                    {{calculateJumlahCAGR2022PendapatanPenengah('LainBandar')}}
                  </td>
                  
                  <td style="text-align:center;">
                    {{calculateJumlahCAGR2022PendapatanPenengah('LainLuarBandar')}}
                  </td>

                  <td style="text-align:center;">
                    {{calculateJumlahCAGR2022PendapatanPenengah('LainJumlah')}}
                  </td>
                </tr>
                     
              </tbody>
              </v-simple-table>
          </v-card-text>
      </v-container>
    </v-card>
    </v-card>
  </div>
</template>
<script>
import Overlay from '../../components/Overlay'
import i18n from "@/i18n";
import axios from "../../plugins/axios";
import hidServices from "@/services/lookupField";
const negerilookup = new hidServices();
import getPusingan from "@/services/pusingan";
const pusingan = new getPusingan();

export default {
  components: {
   Overlay
 },
  async beforeMount(){
   var res = await pusingan.getPusinganDataAll();
   this.lookuppusingan = res;

   this.lookupsample = await pusingan.getSample();
  
},
  Name: "Kaumxstrata",
  computed: {},
  setup() {},
  data: () => ({
    exportthn: "",
    exportbln: "",
    exportps: '',
    exportneg: '',
    snackbar: "",
    showOverlay: false,
   
    item: [
      {
        text: i18n.t("utama"),
        disabled: false,
        href: `paparanutama`,
      },
      {
        text: 'Pendapatan Isi Rumah Bulanan Mengikut Kumpulan Etnik Ketua Isi Rumah dan Strata',
        disabled: true,
        href: "",
      },
    ],
    title: "",
    
    lookupnegeri: [],
    dataz: [],
    datez: [],
    data:[],

    sortedData:[],
    sortedData1:[],


    paparsample:"",
    paparpusingan:"",
    paparpusinganexport: "",
    lookuppusingan: [],
    paparnegeri: "",
    paparnegeriexport: "",
    disablepusingan: true,
    peranan: "",
    disablenegeri: true,
    disablesample:true,
    isShowing:false,


    JumlahBandar2019: "",
    JumlahLuarBandar2019: "",
    JumlahJumlah2019: "",

    JumlahBumiBandar2019: "",
    

  }),
  mounted() {
    this.$store.dispatch("localStorageuser");
    this.permulaan();
 
  },
  methods: {
    goToRoute(url) {
      return `/${i18n.locale}/${url}`;
    },

    // myFunction: function () {	
    //  this.currentYear = (new Date()).getFullYear();
    //  },

     downloadPDF: function () {

      //console.log("masuk")
           
           var sTable = document.getElementById('table1').innerHTML;
     
     var style = "<style>";
     style = style + "body {font: 14px Calibri;}";
     style = style + "table {width: 100%; font: 12px Calibri;}";
     style = style + "table, th, td {border: solid 1px #DDD; border-collapse: collapse;";
     style = style + "padding: 2px 3px;text-align: center;}";
     style = style + "</style>";
     
     // CREATE A WINDOW OBJECT.
     var win = window.open( "http://www.domainname.ext/path.png",
                                  "DescriptiveWindowName");
     win.document.write('<html><head>');
     win.document.write('<title>Pendapatan Isi Rumah Bulanan Penengah</title>');   // <title> FOR PDF HEADER.
     win.document.write(style);          // ADD STYLE INSIDE THE HEAD TAG.
     win.document.write('</head>');
     win.document.write('<body>');
     
     win.document.write('<center>');
     win.document.write(`Negeri = `+this.paparnegeriexport.negeriID +' - '+this.paparnegeriexport.negeri);
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     
     win.document.write(`Sample = `+this.paparsample.sample) 
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     
     win.document.write(`Pusingan = `+this.paparpusinganexport.id);
     win.document.write('<br>');
     win.document.write('<br>');
     
     win.document.write(sTable);         // THE TABLE CONTENTS INSIDE THE BODY TAG.
     win.document.write('</body></html>');
     
     win.document.close(); 	// CLOSE THE CURRENT WINDOW.
     win.setTimeout(function () {
     win.print();    // PRINT THE CONTENTS.
       }, 100)
     },

     downloadExcel: function () {
    //format xls
    var uri = 'data:application/vnd.ms-excel;base64,';
  
    var base64 = function(s) {
        return window.btoa(unescape(encodeURIComponent(s)))
      },
      format = function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) {
          return c[p];
        })
      }
    var sTable = document.getElementById("table1").innerHTML;
    var ctx = {
      worksheet: 'PendapatanKaum&Strata',
      table: sTable
    };
 
    var style = "<style>";
    style = style + "body {font: 12px Calibri;}";
    style = style + "table {width: 100%; font: 12px Calibri;}";
    style = style + "table, th, td {border: solid 1px #DDD; border-collapse: collapse;";
    style = style + "padding: 2px 3px;text-align: center;}";
    style = style + "</style>";

    var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
    tab_text = tab_text + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';

    tab_text = tab_text + '<x:Name>PendapatanKaum&Strata</x:Name>';

    tab_text = tab_text + '<x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>';
    tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
    
    tab_text = tab_text + ('<center>');
    tab_text = tab_text + (`Negeri = `+this.paparnegeriexport.negeriID +' - '+this.paparnegeriexport.negeri);
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');

    tab_text = tab_text + (`Sample = `+this.paparsample.sample);
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    
    tab_text = tab_text + (`Pusingan = `+this.paparpusinganexport.pusingan);
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');

    tab_text = tab_text + (style); 
    tab_text = tab_text + (sTable);  

    tab_text = tab_text + '</body></html>';
   
    var link = document.createElement("a");
    link.download = "PendapatanKaum&Strata.xls";
    link.href = uri + base64(format(tab_text, ctx))
    link.click();
 
    // window.location.href = uri + window.btoa(tab_text);
  
},

// downloadExcel: function () {
//   var location = 'data:application/vnd.ms-excel;base64,';
// 	var excelTemplate = '<html> ' +
// 		'<head> ' +
// 		'<meta http-equiv="content-type" content="text/plain; charset=UTF-8"/> ' +
// 		'</head> ' +
// 		'<body> ' +
// 		document.getElementById("table1").innerHTML +
// 		'</body> ' +
// 		'</html>'
// 	window.location.href = location + window.btoa(excelTemplate);
// },

    async cari() {
      this.isShowing="true"
      this.showOverlay = true;
      this.Bandar2019()
      this.TanpaWajaran2022()
      
    },

    async Bandar2019() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/JadualAwalan/getLookupKaum?NG=`+this.paparnegeriexport.negeriID,{
        });
        this.dataz = res.data.data;
      }
       catch (error) {
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },

    async TanpaWajaran2022() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/JadualAwalan/getKaumTanpaWajaran?NG=`+this.paparnegeriexport.negeriID+`&P=`+this.paparpusinganexport.id+`&S=`+this.paparsample.id,{
        });
        //this.sortedData = res.data.data;
        this.data = res.data.data;
        this.showOverlay = false;
        
      }
       catch (error) {
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },
        

// ******************************* MULA 2022 (TANPA WAJARAN) PENDAPATAN PURATA *****************************
     calculateJumlahBandarLuarBandar2022(st){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;

        for(var i = 0;i < arrLength ;i++){
          if (st == 1) {
              if ((currData[i].ST == 1 || currData[i].ST == 2)){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                }
          }
          if (st == 2) {
              if ((currData[i].ST == 0 || currData[i].ST >= 3)){
                  totalHID = totalHID + 1
                  jpkasb = jpkasb + Number(currData[i].JPKASB);
                }
          }
        }
        var dataToReturn = Number(jpkasb)/Number(totalHID);

            if(isNaN(dataToReturn)){
            return "-";
            
            }else{
            return Math.round(dataToReturn);
          }
      },

      calculatePenkasarJumlah(){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = arrLength;

          for(var i = 0;i < arrLength;i++){
              jpkasb = jpkasb + Number(currData[i].JPKASB);
          }
            var dataToReturn = Number(jpkasb)/Number(totalHID);

            if(isNaN(dataToReturn)){
            return "-";
            }else{
            return Math.round(dataToReturn);
          }
      },

      //Pendapatan Purata Bumiputra
      calculateBumiBandarLuarBandar2022(st){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;

        for(var i = 0;i < arrLength ;i++){
          if (st == 1){
              if (currData[i].KKIRB <= 499999 && (currData[i].ST == 1 || currData[i].ST == 2 )){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                }
          }
          if (st == 2) {
              if (currData[i].KKIRB <= 499999 && (currData[i].ST == 0 || currData[i].ST >= 3)){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                }
          }
        }
            var dataToReturn = Number(jpkasb)/Number(totalHID);
            if(isNaN(dataToReturn)){
            return "-";
            }else{
            return Math.round(dataToReturn);
          }
      },

      calculatePenkasarBumi(){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;

        for(var i = 0;i < arrLength ;i++){
              if (currData[i].KKIRB <= 499999){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                }
        }
            var dataToReturn = Number(jpkasb)/Number(totalHID);
            if(isNaN(dataToReturn)){
            return "-";
            }else{
            return Math.round(dataToReturn);
          }
      },

      //Pendapatan Purata Cina
      calculateCinaBandarLuarBandar2022(st){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;

        for(var i = 0;i < arrLength ;i++){
          if (st == 1){
              if ((currData[i].KKIRB >= 511000 && currData[i].KKIRB <= 599999) && (currData[i].ST == 1 || currData[i].ST == 2 )){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number( currData[i].JPKASB);
                }
          }
          if (st == 2) {
              if ((currData[i].KKIRB >= 511000 && currData[i].KKIRB <= 599999) && (currData[i].ST == 0 || currData[i].ST >= 3)){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                }
          }
        }
            var dataToReturn = Number(jpkasb)/Number(totalHID);
            if(isNaN(dataToReturn)){
            return "-";
            }else{
            return Math.round(dataToReturn);
          }
      },

      calculatePenkasarCina(){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;

        for(var i = 0;i < arrLength ;i++){
              if (currData[i].KKIRB >= 511000 && currData[i].KKIRB <= 599999){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                }
        }
            var dataToReturn = Number(jpkasb)/Number(totalHID);
            if(isNaN(dataToReturn)){
            return "-";
            }else{
            return Math.round(dataToReturn);
          }
      },

      //Pendapatan Purata India
      calculateIndiaBandarLuarBandar2022(st){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;

        for(var i = 0;i < arrLength ;i++){
          if (st == 1){
              if ((currData[i].KKIRB >= 611000 && currData[i].KKIRB <= 699999) && (currData[i].ST == 1 || currData[i].ST == 2 )){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                }
          }
          if (st == 2) {
              if ((currData[i].KKIRB >= 611000 && currData[i].KKIRB <= 699999) && (currData[i].ST == 0 || currData[i].ST >= 3)){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                }
          }
        }
            var dataToReturn = Number(jpkasb)/Number(totalHID);
            if(isNaN(dataToReturn)){
            return "-";
            }else{
            return Math.round(dataToReturn);
            }
      },

      calculatePenkasarIndia(){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;

        for(var i = 0;i < arrLength ;i++){
              if (currData[i].KKIRB >= 611000 && currData[i].KKIRB <= 699999){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                }
        }
            var dataToReturn = Number(jpkasb)/Number(totalHID);
            if(isNaN(dataToReturn)){
            return "-";
            }else{
            return Math.round(dataToReturn);
          }
      },

      //Pendapatan Purata Lain-lain
      calculateLainBandarLuarBandar2022(st){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;

        for(var i = 0;i < arrLength ;i++){
          if (st == 1){
              if ((currData[i].KKIRB >= 711000 && currData[i].KKIRB <= 999999) && (currData[i].ST == 1 || currData[i].ST == 2 )){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                }
          }
          if (st == 2) {
              if ((currData[i].KKIRB >= 711000 && currData[i].KKIRB <= 999999) && (currData[i].ST == 0 || currData[i].ST >= 3)){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                }
          }
        }
            var dataToReturn = Number(jpkasb)/Number(totalHID);
            if(isNaN(dataToReturn)){
            return "-";
            }else{
            return Math.round(dataToReturn);
            }
      },

      calculatePenkasarLain(){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;

        for(var i = 0;i < arrLength ;i++){
              if (currData[i].KKIRB >= 711000 && currData[i].KKIRB <= 999999){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                }
        }
            var dataToReturn = Number(jpkasb)/Number(totalHID);
            if(isNaN(dataToReturn)){
            return "-";
            }else{
            return Math.round(dataToReturn);
          }
      },

    // ******************************* TAMAT 2022 (TANPA WAJARAN) PENDAPATAN PURATA *****************************

    // ******************************* 2022 (TANPA WAJARAN) PENDAPATAN PENENGAH  *****************************
     calculatemediankumulatif(arrayjpkasb){
      // console.log(arrayjpkasb)
              var cubalagi = 0;
              var listkumulatif2 = [];
              

              if(arrayjpkasb.length < 1){
                  return dataToReturn = "-";
              }

              if(arrayjpkasb.length > 0){
                for(var y = 0;y < arrayjpkasb.length;y++){
                  cubalagi = cubalagi + 1/arrayjpkasb.length;
                  listkumulatif2.push(cubalagi)
                }
                  var medianFirst = 0;
                  var medianjpkasb = 0;
                  var half = 0;
                  arrayjpkasb.sort((a,b)=>a-b)
                  
                  half = Math.floor(listkumulatif2.length / 2);

                  // console.log("luar" + half)
                  // console.log("papeje" + listkumulatif2.length % 2)
                  if (listkumulatif2.length % 2 == 0)
                  { 
                      // console.log("dalam" + half)
                    medianjpkasb = Number(arrayjpkasb[half - 1]);
                  }
                  else
                  {
                    // console.log("dalam2" + half)
                    medianjpkasb =  (Number(arrayjpkasb[half - 1]) + Number(arrayjpkasb[half])) / 2.0;
                  }
                  
                var dataToReturn = Number(medianjpkasb);
                if(isNaN(dataToReturn)){
                  return "-";
                }else{
                  return Math.round(dataToReturn);
                }
              }
           },
     
     calculatePenengahJumlahBandarLuarBandar2022(st){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;
        var listjpksbuntukcarimin = [];

        //kira JPKASB Negeri
        for(var i = 0;i < arrLength ;i++){
          if(currData[i].JPKASB == null || currData[i].JPKASB == ""){
                currData[i].JPKASB = 0;
          }

          if (st == 1) {
              if (currData[i].ST == "1" || currData[i].ST == "2"){
                //console.log(this.sortedData[i])
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                //untuk cari min
                listjpksbuntukcarimin.push(currData[i].JPKASB);
                }
          }
          if (st == 2) {
              if (currData[i].ST == "0" || currData[i].ST >= "3"){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                //untuk cari min
                listjpksbuntukcarimin.push(currData[i].JPKASB);
                }
          }
        }
                return  this.calculatemediankumulatif(listjpksbuntukcarimin)
      },

      calculatePenengahJPKASBJumlah(){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;
        var listjpksbuntukcarimin = [];

        for(var i = 0;i < arrLength ;i++){
              jpkasb = jpkasb + Number(currData[i].JPKASB);
              //untuk cari min
              listjpksbuntukcarimin.push(currData[i].JPKASB);                        
        }
              return  this.calculatemediankumulatif(listjpksbuntukcarimin)
      },

      //Pendapatan Penengah Bumiputra
      calculatePenengahBumiBandarLuarBandar2022(st){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;
        var listjpksbuntukcarimin = [];

        //kira JPKASB Negeri
        for(var i = 0;i < arrLength ;i++){
          if(currData[i].JPKASB == null || currData[i].JPKASB == ""){
              currData[i].JPKASB = 0;
          }
          if (st == 1) {
              if ((currData[i].KKIRB <= 499999) && (currData[i].ST == 1 || currData[i].ST == 2)){
                //console.log(this.sortedData[i].KKIRB)
                  totalHID = totalHID + 1
                  jpkasb = jpkasb + Number(currData[i].JPKASB);
                  //untuk cari min
                  listjpksbuntukcarimin.push(currData[i].JPKASB);
              }
          }
              
          if (st == 2) {
              if ((currData[i].KKIRB <= 499999) && (currData[i].ST == 0 || currData[i].ST >= 3)){
                  totalHID = totalHID + 1
                  jpkasb = jpkasb + Number(currData[i].JPKASB);
                  //untuk cari min
                  listjpksbuntukcarimin.push(currData[i].JPKASB);
              }
          }
                        
        }
                return  this.calculatemediankumulatif(listjpksbuntukcarimin)
      },

      calculatePenengahJPKASBBumi(){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;
        var listjpksbuntukcarimin = [];

        for(var i = 0;i < arrLength ;i++){
          if(currData[i].JPKASB == null || currData[i].JPKASB == ""){
              currData[i].JPKASB = 0;
          }
          if (currData[i].KKIRB <= 499999){
              totalHID = totalHID + 1
              jpkasb = jpkasb + Number(currData[i].JPKASB);
              //untuk cari min
              listjpksbuntukcarimin.push(currData[i].JPKASB);
          }   
      }
                return  this.calculatemediankumulatif(listjpksbuntukcarimin)
      },

      //Pendapatan Penengah Cina
      calculatePenengahCinaBandarLuarBandar2022(st){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;
        var listjpksbuntukcarimin = [];

        //kira JPKASB Negeri
        for(var i = 0;i < arrLength ;i++){
          if(currData[i].JPKASB == null || currData[i].JPKASB == ""){
            currData[i].JPKASB = 0;
          }
          if (st == 1) {
              if ((currData[i].KKIRB >= 511000 && currData[i].KKIRB <= 599999) && (currData[i].ST == 1 || currData[i].ST == 2)){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                //untuk cari min
                listjpksbuntukcarimin.push(currData[i].JPKASB);
              }
          }
               
          if (st == 2) {
              if ((currData[i].KKIRB >= 511000 && currData[i].KKIRB <= 599999) && (currData[i].ST == 0 || currData[i].ST >= 3)){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                //untuk cari min
                listjpksbuntukcarimin.push(currData[i].JPKASB);
              }
          }             
        }
                return  this.calculatemediankumulatif(listjpksbuntukcarimin)
      },

      calculatePenengahJPKASBCina(){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;
        var listjpksbuntukcarimin = [];

        for(var i = 0;i < arrLength ;i++){
          if(currData[i].JPKASB == null || currData[i].JPKASB == ""){
            currData[i].JPKASB = 0;
          }
          if (currData[i].KKIRB >= 511000 && currData[i].KKIRB <= 599999){
            totalHID = totalHID + 1
            jpkasb = jpkasb + Number(currData[i].JPKASB);
            //untuk cari min
            listjpksbuntukcarimin.push(currData[i].JPKASB);
          }                     
      }
                return  this.calculatemediankumulatif(listjpksbuntukcarimin)
      },

      //Pendapatan Penengah India
      calculatePenengahIndiaBandarLuarBandar2022(st){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;
        var listjpksbuntukcarimin = [];

        //kira JPKASB Negeri
        for(var i = 0;i < arrLength ;i++){
          if(currData[i].JPKASB == null || currData[i].JPKASB == ""){
            currData[i].JPKASB = 0;
          }
          if (st == 1) {
              if ((currData[i].KKIRB >= 611000 && currData[i].KKIRB <= 699999) && (currData[i].ST == 1 || currData[i].ST == 2)){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                //untuk cari min
                listjpksbuntukcarimin.push(currData[i].JPKASB);
              }
          }
               
          if (st == 2) {
              if ((currData[i].KKIRB >= 611000 && currData[i].KKIRB <= 699999) && (currData[i].ST == 0 || currData[i].ST >= 3)){
                totalHID = totalHID + 1
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                //total = Number(penkasar.toFixed(2));
                //untuk cari min
                listjpksbuntukcarimin.push(currData[i].JPKASB);
              }
          }            
        }
                return  this.calculatemediankumulatif(listjpksbuntukcarimin)
      },

      calculatePenengahJPKASBIndia(){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;
        var listjpksbuntukcarimin = [];

        for(var i = 0;i < arrLength ;i++){
          if(currData[i].JPKASB == null || currData[i].JPKASB == ""){
            currData[i].JPKASB = 0;
          }
          if (currData[i].KKIRB >= 611000 && currData[i].KKIRB <= 699999){
            totalHID = totalHID + 1;
            jpkasb = jpkasb + Number(currData[i].JPKASB);
            //untuk cari min
            listjpksbuntukcarimin.push(currData[i].JPKASB);
          }        
      }
                return  this.calculatemediankumulatif(listjpksbuntukcarimin)
      },

      //Pendapatan Penengah Lain-lain
      calculatePenengahLainBandarLuarBandar2022(st){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;
        var listjpksbuntukcarimin = [];

        //kira JPKASB Negeri
        for(var i = 0;i < arrLength ;i++){
         if(currData[i].JPKASB == null || currData[i].JPKASB == "") {
            currData[i].JPKASB = 0;
          }
          if (st == 1) {
              if((currData[i].KKIRB >= 711000 && currData[i].KKIRB <= 999999) && (currData[i].ST == 1 || currData[i].ST == 2)){
                totalHID = totalHID + 1;
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                //untuk cari min
                listjpksbuntukcarimin.push(currData[i].JPKASB);
              }
          }
          if (st == 2) {
              if((currData[i].KKIRB >= 711000 && currData[i].KKIRB <= 999999) && (currData[i].ST == 0 || currData[i].ST >= 3)){
                totalHID = totalHID + 1;
                jpkasb = jpkasb + Number(currData[i].JPKASB);
                //untuk cari min
                listjpksbuntukcarimin.push(currData[i].JPKASB);
              }
          }              
        }
                return  this.calculatemediankumulatif(listjpksbuntukcarimin)
      },

      calculatePenengahJPKASBLain(){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalHID = 0;
        var listjpksbuntukcarimin = [];

        for(var i = 0;i < arrLength ;i++){
          if(currData[i].JPKASB == null || currData[i].JPKASB == ""){
            currData[i].JPKASB = 0;
          }
          if (currData[i].KKIRB >= 711000 && currData[i].KKIRB <= 999999){
            totalHID = totalHID + 1;
            jpkasb = jpkasb + Number(currData[i].JPKASB);
            //untuk cari min
            listjpksbuntukcarimin.push(currData[i].JPKASB);
          }       
      }
               return  this.calculatemediankumulatif(listjpksbuntukcarimin)
      },
    // ******************************* TAMAT 2022 (TANPA WAJARAN) PENDAPATAN PENENGAH  *****************************

    // ************************************ MULA 2022 (BERWAJARAN) PENDAPATAN PURATA *********************************

     calculateJumlahBandarLuarBandar2022Berwajaran(st){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        let totalWajaran = 0;
        var totalstrata = 0;

          /////////////////semak balik wajaran ada yang null////////////////////////////////////
          for(var i = 0;i < arrLength ;i++){
            if (st == 1) {
                if (currData[i].ST == 1 || currData[i].ST == 2 ){
                  totalWajaran = totalWajaran + Number(currData[i].wajaran);
                  jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
                  totalstrata = totalstrata + 1;
                }
            }
            if (st == 2) {
                if (currData[i].ST == 0 || currData[i].ST >= 3){
                  totalWajaran = totalWajaran + Number(currData[i].wajaran);
                  jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
                  totalstrata = totalstrata + 1;
                }
            }
          }
              var dataToReturn = Number(jpkasb)/Number(totalWajaran);
              if(isNaN(dataToReturn)){
              return "-";
              }else{
              return Math.round(dataToReturn);
              }
      },

      calculatePenkasarJumlahBerwajaran(){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        let totalWajaran = 0;
        var responwajaran = 0;

        for(var i = 0;i < arrLength ;i++){
                totalWajaran = totalWajaran + Number(currData[i].wajaran);
                jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
        }
            var dataToReturn = Number(jpkasb)/Number(totalWajaran);
            if(isNaN(dataToReturn)){
            return "-";
            }else{
            return Math.round(dataToReturn);
            }
      },

      calculateBumiBandarLuarBandar2022Berwajaran(st){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        let totalWajaran = 0;

        for(var i = 0;i < arrLength ;i++){
          if(currData[i].JPKASB == null || currData[i].JPKASB == "" || currData[i].wajaran == null) {
                currData[i].JPKASB = 0;
                currData[i].wajaran = 1;
            }
          if (st == 1){
              if (currData[i].KKIRB <= 499999 && (currData[i].ST == 1 || currData[i].ST == 2 )){
                  totalWajaran = totalWajaran + Number(currData[i].wajaran);
                  jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
                }
          }
          if (st == 2) {
              if (currData[i].KKIRB <= 499999 && (currData[i].ST == 0 || currData[i].ST >= 3)){
                  totalWajaran = totalWajaran + Number(currData[i].wajaran);
                  jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
                }
          }
        }
            var dataToReturn = Number(jpkasb)/Number(totalWajaran);
            if(isNaN(dataToReturn)){
            return "-";
            }else{
            return Math.round(dataToReturn);
            }
      },

      calculatePenkasarBumiBerwajaran(){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        let totalWajaran = 0;

        for(var i = 0;i < arrLength ;i++){
              if(currData[i].JPKASB == null || currData[i].JPKASB == "" || currData[i].wajaran == null) {
                currData[i].JPKASB = 0;
                currData[i].wajaran = 1;
              }
              if (currData[i].KKIRB <= 499999){
                totalWajaran = totalWajaran + Number(currData[i].wajaran);
                jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
              }
        }
        var dataToReturn = Number(jpkasb)/Number(totalWajaran);
        if(isNaN(dataToReturn)){
        return "-";
        }else{
        return Math.round(dataToReturn);
        }
      },

      calculateCinaBandarLuarBandar2022Berwajaran(st){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        let totalWajaran = 0;

        for(var i = 0;i < arrLength ;i++){
          if(currData[i].JPKASB == null || currData[i].JPKASB == "" || currData[i].wajaran == null) {
                currData[i].JPKASB = 0;
                currData[i].wajaran = 1;
            }
          if (st == 1){
              if ((currData[i].KKIRB >= 511000 && currData[i].KKIRB <= 599999) && (currData[i].ST == 1 || currData[i].ST == 2 )){
                  totalWajaran = totalWajaran + Number(currData[i].wajaran);
                  jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
                }
          }
          if (st == 2) {
              if ((currData[i].KKIRB >= 511000 && currData[i].KKIRB <= 599999) && (currData[i].ST == 0 || currData[i].ST >= 3)){
                  totalWajaran = totalWajaran + Number(currData[i].wajaran);
                  jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
                }
          }
        }
        var dataToReturn = Number(jpkasb)/Number(totalWajaran);
        if(isNaN(dataToReturn)){
        return "-";
        }else{
        return Math.round(dataToReturn);
        }
      },

      calculatePenkasarCinaBerwajaran(){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        let totalWajaran = 0;

        for(var i = 0;i < arrLength ;i++){
              if(currData[i].JPKASB == null || currData[i].JPKASB == "" || currData[i].wajaran == null) {
                  currData[i].JPKASB = 0;
                  currData[i].wajaran = 1;
              }
              if (currData[i].KKIRB >= 511000 && currData[i].KKIRB <= 599999){
                totalWajaran = totalWajaran + Number(currData[i].wajaran);
                jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
              }
        }
        var dataToReturn = Number(jpkasb)/Number(totalWajaran);
        if(isNaN(dataToReturn)){
        return "-";
        }else{
        return Math.round(dataToReturn);
        }
      },

      calculateIndiaBandarLuarBandar2022Berwajaran(st){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        let totalWajaran = 0;

        for(var i = 0;i < arrLength ;i++){
          if(currData[i].JPKASB == null || currData[i].JPKASB == "" || currData[i].wajaran == null) {
                currData[i].JPKASB = 0;
                currData[i].wajaran = 1;
            }
          if (st == 1){
              if ((currData[i].KKIRB >= 611000 && currData[i].KKIRB <= 699999) && (currData[i].ST == 1 || currData[i].ST == 2 )){
                  totalWajaran = totalWajaran + Number(currData[i].wajaran);
                  jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
              }
          }
          if (st == 2) {
              if ((currData[i].KKIRB >= 611000 && currData[i].KKIRB <= 699999) && (currData[i].ST == 0 || currData[i].ST >= 3)){
                  totalWajaran = totalWajaran + Number(currData[i].wajaran);
                  jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
              }
          }
        }
        var dataToReturn = Number(jpkasb)/Number(totalWajaran);
        if(isNaN(dataToReturn)){
        return "-";
        }else{
        return Math.round(dataToReturn);
        }
      },

      calculatePenkasarIndiaBerwajaran(){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        let totalWajaran = 0;

        for(var i = 0;i < arrLength ;i++){
              if(currData[i].JPKASB == null || currData[i].JPKASB == "" || currData[i].wajaran == null) {
                currData[i].JPKASB = 0;
                currData[i].wajaran = 1;
              }
              if (currData[i].KKIRB >= 611000 && currData[i].KKIRB <= 699999){
                totalWajaran = totalWajaran + Number(currData[i].wajaran);
                jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
              }
        }
        var dataToReturn = Number(jpkasb)/Number(totalWajaran);
        if(isNaN(dataToReturn)){
        return "-";
        }else{
        return Math.round(dataToReturn);
        }
      },

      calculateLainBandarLuarBandar2022Berwajaran(st){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        let totalWajaran = 0;

        for(var i = 0;i < arrLength ;i++){
          if(currData[i].JPKASB == null || currData[i].JPKASB == "" || currData[i].wajaran == null) {
                currData[i].JPKASB = 0;
                currData[i].wajaran = 1;
            }
          if (st == 1){
              if ((currData[i].KKIRB >= 711000 && currData[i].KKIRB <= 999999) && (currData[i].ST == 1 || currData[i].ST == 2)){
                  totalWajaran = totalWajaran + Number(currData[i].wajaran);
                  jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
              }
          }
          if (st == 2) {
              if ((currData[i].KKIRB >= 711000 && currData[i].KKIRB <= 999999) && (currData[i].ST == 0 || currData[i].ST >= 3)){
                  totalWajaran = totalWajaran + Number(currData[i].wajaran);
                  jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
              }
          }
        }
        var dataToReturn = Number(jpkasb)/Number(totalWajaran);
        if(isNaN(dataToReturn)){
        return "-";
        }else{
        return Math.round(dataToReturn);
        }
      },

      calculatePenkasarLainBerwajaran(){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        let totalWajaran = 0;

        for(var i = 0;i < arrLength ;i++){
          if(currData[i].JPKASB == null || currData[i].JPKASB == "" || currData[i].wajaran == null) {
                currData[i].JPKASB = 0;
                currData[i].wajaran = 1;
            }
              if (currData[i].KKIRB >= 711000 && currData[i].KKIRB <= 999999){
                totalWajaran = totalWajaran + Number(currData[i].wajaran);
                jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
              }
        }
        var dataToReturn = Number(jpkasb)/Number(totalWajaran);
        if(isNaN(dataToReturn)){
        return "-";
        }else{
        return Math.round(dataToReturn);
        }
      },

    // ******************************* TAMAT 2022 (BERWAJARAN) PENDAPATAN PURATA *****************************

    // ************************************ MULA 2022 (BERWAJARAN) PENDAPATAN PENENGAH *********************************

      calculatemediankumulatifWajaran(listjpksbuntukcarimin, arrayjpkasb){
      // console.log(arrayjpkasb)
              var kirakumulatif = 0;
              var dataToReturn = "-";
              var listkumulatif2 = [];
              
              if(arrayjpkasb.length < 1){
                  return dataToReturn = "-";
              }

              if(arrayjpkasb.length > 0){
                for(var j = 0;j < arrayjpkasb.length;j++){
                  if(listkumulatif2 == 0){
                    kirakumulatif = arrayjpkasb[j].nisbahWajaran
                    listkumulatif2.push(arrayjpkasb[j].nisbahWajaran)
                  }else{
                    kirakumulatif = kirakumulatif + arrayjpkasb[j].nisbahWajaran;
                    listkumulatif2.push(arrayjpkasb[j].nisbahWajaran)
                  }
                }
                  var medianFirst = 0;
                  var medianjpkasb = 0;
                  var half = 0;
                  listjpksbuntukcarimin.sort((a,b)=>a-b)
                  
                  half = Math.floor(listkumulatif2.length / 2);

                  if (listkumulatif2.length % 2 == 0)
                  { 
                    medianjpkasb = Number(listjpksbuntukcarimin[half - 1]);
                  }
                  else
                  {
                    medianjpkasb =  (Number(listjpksbuntukcarimin[half - 1]) + Number(listjpksbuntukcarimin[half])) / 2.0;
                  }
                  
                dataToReturn = Number(medianjpkasb);
                if(isNaN(dataToReturn)){
                  return "-";
                }else{
                  return Math.round(dataToReturn);
                }
              }
           },
           
     calculateJumlahBandarLuarBandar2022PenengahBerwajaran(st){
        
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
          if (st == 1) {
              if (currData[x].sts == 1){
                //console.log(this.sortedData[i])
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
          }
          if (st == 2) {
              if (currData[x].sts == 2){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
          }
        }

        for(var y = 0;y < arrLength ;y++){
          if (st == 1) {
              if (currData[y].sts == 1){
                //console.log(this.sortedData[i])
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          }
          if (st == 2) {
              if (currData[y].sts == 2){
                //console.log(this.sortedData[i])
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          
            }
          }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)
      },

      calculateJumlah2022PenengahBerwajaran(){
        
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
          }
        
        for(var y = 0;y < arrLength ;y++){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
            }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)
      },


      calculateBumiBandarLuarBandar2022PenengahBerwajaran(st){
        
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
          if (st == 1) {
              if (currData[x].KKIRB <= 499999 && currData[x].sts == 1){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
          }
          if (st == 2) {
              if (currData[x].KKIRB <= 499999 && currData[x].sts == 2){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
          }
        }

        for(var y = 0;y < arrLength ;y++){
          if (st == 1) {
              if (currData[y].KKIRB <= 499999 && currData[y].sts == 1){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          }
          if (st == 2) {
              if (currData[y].KKIRB <= 499999 && currData[y].sts == 2){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          
            }
          }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)
      },

      calculateBumi2022PenengahBerwajaran(){
        
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
              if (currData[x].KKIRB <= 499999 ){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
          
              if (currData[x].KKIRB <= 499999 ){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
          }

        for(var y = 0;y < arrLength ;y++){
              if (currData[y].KKIRB <= 499999 ){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }

              if (currData[y].KKIRB <= 499999 ){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)
      },

      calculateCinaBandarLuarBandar2022PenengahBerwajaran(st){
        
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
          if (st == 1) {
              if ((currData[x].KKIRB >= 511000 && currData[x].KKIRB <= 599999) && currData[x].sts == 1){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
          }
          if (st == 2) {
              if ((currData[x].KKIRB >= 511000 && currData[x].KKIRB <= 599999) && currData[x].sts == 2){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
          }
        }

        for(var y = 0;y < arrLength ;y++){
          if (st == 1) {
              if ((currData[y].KKIRB >= 511000 && currData[y].KKIRB <= 599999) && currData[y].sts == 1){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          }
          if (st == 2) {
              if ((currData[y].KKIRB >= 511000 && currData[y].KKIRB <= 599999) && currData[y].sts == 2){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          
            }
          }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)
      },

      calculateCina2022PenengahBerwajaran(){
        
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
              if (currData[x].KKIRB >= 511000 && currData[x].KKIRB <= 599999){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
          
              if (currData[x].KKIRB >= 511000 && currData[x].KKIRB <= 599999){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
          }

        for(var y = 0;y < arrLength ;y++){
              if (currData[y].KKIRB >= 511000 && currData[y].KKIRB <= 599999){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }

              if (currData[y].KKIRB >= 511000 && currData[y].KKIRB <= 599999){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)
      },

      calculateIndiaBandarLuarBandar2022PenengahBerwajaran(st){
        
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
          if (st == 1) {
              if ((currData[x].KKIRB >= 611000 && currData[x].KKIRB <= 699999) && currData[x].sts == 1){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
          }
          if (st == 2) {
              if ((currData[x].KKIRB >= 611000 && currData[x].KKIRB <= 699999) && currData[x].sts == 2){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
          }
        }

        for(var y = 0;y < arrLength ;y++){
          if (st == 1) {
              if ((currData[y].KKIRB >= 611000 && currData[y].KKIRB <= 699999) && currData[y].sts == 1){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          }
          if (st == 2) {
              if ((currData[y].KKIRB >= 611000 && currData[y].KKIRB <= 699999) && currData[y].sts == 2){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          
            }
          }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)
      },

      calculateIndia2022PenengahBerwajaran(){
        
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
              if (currData[x].KKIRB >= 611000 && currData[x].KKIRB <= 699999){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
          
              if (currData[x].KKIRB >= 611000 && currData[x].KKIRB <= 699999){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
          }

        for(var y = 0;y < arrLength ;y++){
              if (currData[y].KKIRB >= 611000 && currData[y].KKIRB <= 699999){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }

              if (currData[y].KKIRB >= 611000 && currData[y].KKIRB <= 699999){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)
      },

      calculateLainBandarLuarBandar2022PenengahBerwajaran(st){
        
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
          if (st == 1) {
              if ((currData[x].KKIRB >= 711000 && currData[x].KKIRB <= 999999) && currData[x].sts == 1){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
          }
          if (st == 2) {
              if ((currData[x].KKIRB >= 711000 && currData[x].KKIRB <= 999999) && currData[x].sts == 2){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
          }
        }

        for(var y = 0;y < arrLength ;y++){
          if (st == 1) {
              if ((currData[y].KKIRB >= 711000 && currData[y].KKIRB <= 999999) && currData[y].sts == 1){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          }
          if (st == 2) {
              if ((currData[y].KKIRB >= 711000 && currData[y].KKIRB <= 999999) && currData[y].sts == 2){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          
            }
          }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)
      },

      calculateLain2022PenengahBerwajaran(){
        
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
              if (currData[x].KKIRB >= 711000 && currData[x].KKIRB <= 999999){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
          
              if (currData[x].KKIRB >= 711000 && currData[x].KKIRB <= 999999){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
              }
          }

        for(var y = 0;y < arrLength ;y++){
              if (currData[y].KKIRB >= 711000 && currData[y].KKIRB <= 999999){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }

              if (currData[y].KKIRB >= 711000 && currData[y].KKIRB <= 999999){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)
      },

      
    // ******************************* TAMAT 2022 (WAJARAN) PENDAPATAN PENENGAH *****************************

    // ******************************* MULA CAGR 2022 PENDAPATAN PURATA  *****************************

    calculateJumlahCAGR2022PendapatanPurata(typeST){

      if(this.dataz != ''){
        var row = '';
        var col = '';
        var conBerwajaran = 0;

        // ***** Pendapatan Purata CAGR 2022 Jumlah
        if(typeST == 'Bandar'){
          row =  "1"  
          col = "10"
          conBerwajaran = this.calculateJumlahBandarLuarBandar2022Berwajaran('1')
        }

        if(typeST == 'LuarBandar'){
          row =  "1"  
          col = "11"
          conBerwajaran = this.calculateJumlahBandarLuarBandar2022Berwajaran('2')
        }

        if(typeST == 'Jumlah'){
          row =  "1"  
          col = "12"
          conBerwajaran = this.calculatePenkasarJumlahBerwajaran('1','1')
        }

        // ***** Pendapatan Purata CAGR 2022 Bumiputera
        if(typeST == 'BumiBandar'){
          row =  "2"  
          col = "10"
          conBerwajaran = this.calculateBumiBandarLuarBandar2022Berwajaran('1')
        }

        if(typeST == 'BumiLuarBandar'){
          row =  "2"  
          col = "11"
          conBerwajaran = this.calculateBumiBandarLuarBandar2022Berwajaran('2')
        }

        if(typeST == 'BumiJumlah'){
          row =  "2"  
          col = "12"
          conBerwajaran = this.calculatePenkasarBumiBerwajaran('1','1')
        }

        // ***** Pendapatan Purata CAGR 2022 Cina
        if(typeST == 'CinaBandar'){
          row =  "3"  
          col = "10"
          conBerwajaran = this.calculateCinaBandarLuarBandar2022Berwajaran('1')
        }

        if(typeST == 'CinaLuarBandar'){
          row =  "3"  
          col = "11"
          conBerwajaran = this.calculateCinaBandarLuarBandar2022Berwajaran('2')
        }

        if(typeST == 'CinaJumlah'){
          row =  "3"  
          col = "12"
          conBerwajaran = this.calculatePenkasarCinaBerwajaran('1','1')
        }

        // ***** Pendapatan Purata CAGR 2022 India
        if(typeST == 'IndiaBandar'){
          row =  "4"  
          col = "10"
          conBerwajaran = this.calculateIndiaBandarLuarBandar2022Berwajaran('1')
        }

        if(typeST == 'IndiaLuarBandar'){
          row =  "4"  
          col = "11"
          conBerwajaran = this.calculateIndiaBandarLuarBandar2022Berwajaran('2')
        }

        if(typeST == 'IndiaJumlah'){
          row =  "4"  
          col = "12"
          conBerwajaran = this.calculatePenkasarIndiaBerwajaran('1','1')
        }

        // ***** Pendapatan Purata CAGR 2022 Lain-lain
        if(typeST == 'LainBandar'){
          row =  "5"  
          col = "10"
          conBerwajaran = this.calculateLainBandarLuarBandar2022Berwajaran('1')
        }

        if(typeST == 'LainLuarBandar'){
          row =  "5"  
          col = "11"
          conBerwajaran = this.calculateLainBandarLuarBandar2022Berwajaran('2')
        }

        if(typeST == 'LainJumlah'){
          row =  "5"  
          col = "12"
          conBerwajaran = this.calculatePenkasarLainBerwajaran('1','1')
        }
            var currData = this.dataz.dataPurata2019;
            var valuePurata = 0;
            
            for(var y = 0; y<currData.length; y++){
              if(this.dataz.dataPurata2019[y].Row == row && this.dataz.dataPurata2019[y].Col == col ){
                  valuePurata = this.dataz.dataPurata2019[y].Value
              }
            }
      }
     
      var totalPurata = Number(conBerwajaran) / Number(valuePurata)

      var data = Math.log(totalPurata)

      var dataToReturn = Number(data) / 0.03

      if(isNaN(dataToReturn)){
        return "-";
        }else{
        //return Math.log(dataToReturn);
        return dataToReturn.toFixed(1);
        }
    },

    // ******************************* TAMAT CAGR 2022 PENDAPATAN PURATA  *****************************

    // ******************************* MULA CAGR 2022 PENDAPATAN PENENGAH  *****************************

    calculateJumlahCAGR2022PendapatanPenengah(typeST){

      if(this.dataz != ''){
        var row = '';
        var col = '';
        var conBerwajaran = 0;

        // ***** Pendapatan Penengah CAGR 2022 Jumlah
        if(typeST == 'Bandar'){
          row = "1"  
          col = "7"
          conBerwajaran = this.calculateJumlahBandarLuarBandar2022PenengahBerwajaran('1')
        }

        if(typeST == 'LuarBandar'){
          row = "1"  
          col = "8"
          conBerwajaran = this.calculateJumlahBandarLuarBandar2022PenengahBerwajaran('2')
        }

        if(typeST == 'Jumlah'){
          row = "1"  
          col = "9"
          conBerwajaran = this.calculateJumlah2022PenengahBerwajaran()
        }

        // ***** Pendapatan Penengah CAGR 2022 Bumiputera
        if(typeST == 'BumiBandar'){
          row = "2"  
          col = "7"
          conBerwajaran = this.calculateBumiBandarLuarBandar2022PenengahBerwajaran('1')
        }

        if(typeST == 'BumiLuarBandar'){
          row = "2"  
          col = "8"
          conBerwajaran = this.calculateBumiBandarLuarBandar2022PenengahBerwajaran('2')
        }

        if(typeST == 'BumiJumlah'){
          row = "2"  
          col = "9"
          conBerwajaran = this.calculateBumi2022PenengahBerwajaran()
        }

        // ***** Pendapatan Penengah CAGR 2022 Cina
        if(typeST == 'CinaBandar'){
          row = "3"  
          col = "7"
          conBerwajaran = this.calculateCinaBandarLuarBandar2022PenengahBerwajaran('1')
        }

        if(typeST == 'CinaLuarBandar'){
          row = "3"  
          col = "8"
          conBerwajaran = this.calculateCinaBandarLuarBandar2022PenengahBerwajaran('2')
        }

        if(typeST == 'CinaJumlah'){
          row = "3"  
          col = "9"
          conBerwajaran = this.calculateCina2022PenengahBerwajaran()
        }

        // ***** Pendapatan Penengah CAGR 2022 India
        if(typeST == 'IndiaBandar'){
          row = "4"  
          col = "7"
          conBerwajaran = this.calculateIndiaBandarLuarBandar2022PenengahBerwajaran('1')
        }

        if(typeST == 'IndiaLuarBandar'){
          row = "4"  
          col = "8"
          conBerwajaran = this.calculateIndiaBandarLuarBandar2022PenengahBerwajaran('2')
        }

        if(typeST == 'IndiaJumlah'){
          row = "4"  
          col = "9"
          conBerwajaran = this.calculateIndia2022PenengahBerwajaran()
        }

        // ***** Pendapatan Penengah CAGR 2022 Lain-lain
        if(typeST == 'LainBandar'){
          row = "5"  
          col = "7"
          conBerwajaran = this.calculateLainBandarLuarBandar2022PenengahBerwajaran('1')
        }

        if(typeST == 'LainLuarBandar'){
          row = "5"  
          col = "8"
          conBerwajaran = this.calculateLainBandarLuarBandar2022PenengahBerwajaran('2')
        }

        if(typeST == 'LainJumlah'){
          row = "5"  
          col = "9"
          conBerwajaran = this.calculateLain2022PenengahBerwajaran()
        }

            var currData = this.dataz.dataPurata2019;
            var valuePurata = 0;
            
            for(var y = 0; y<currData.length; y++){
              if(this.dataz.dataPurata2019[y].Row == row && this.dataz.dataPurata2019[y].Col == col ){
                  valuePurata = this.dataz.dataPurata2019[y].Value
              }
            }
      }
     
      var totalPurata = Number(conBerwajaran) / Number(valuePurata)

      var data = Math.log(totalPurata)

      var dataToReturn = Number(data) / 0.03

      if(isNaN(dataToReturn)){
        return "-";
        }else{
        //return Math.log(dataToReturn);
        return dataToReturn.toFixed(1);
        }
    },

    // ******************************* TAMAT CAGR 2022 PENDAPATAN PENENGAH  *****************************



    async permulaan() {

      this.peranan = this.$store.state.localStorageuser.role;
      this.paparnegeriexport = this.$store.state.localStorageuser.kodneg;
      let negeri = await negerilookup.getNegeri();
      let role = ["PP", "PO", "FE", "RESPONDENT"]
      this.disablenegeri =
      role.includes(this.peranan) === true
          ? true
          : false;
      this.disablesample = role.includes(this.peranan) !== true
          ? true
          : false;
      const Negeri = [];
      negeri.data.data.forEach(async function (element) {
        if ((element.negeri !== "Admin") && (element.negeri !== "Responden")) {
          Negeri.push({
            negeriID: `${element.negeriID}`,
            negeri: `${element.negeri}`,
          });
        }
      });
      this.lookupnegeri = Negeri;

      for(var i =0;i<this.lookupnegeri.length;i++){
        if(this.lookupnegeri[i].negeriID == this.paparnegeriexport){
          this.paparnegeriexport = this.lookupnegeri[i];
        }
      }
    },
    async paparlookupsample(){
      //console.log(this.paparnegeriexport)
      this.negeri = this.paparnegeriexport.negeri; 
      //console.log(this.negeri)
      this.disablesample = false;
      this.paparsample = "";
      this.paparpusinganexport = "";
      //this.paparsampleexport();
    },
   
  },
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
  margin: 50px auto;
}
/* tr {
  background: #eee;
} */

td,
th {
  padding: 10px;
  border: 1px solid #ccc;
  text-align: left;
  font-size: 18px;
}
</style>


          